<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="上传本地合同"
    custom-class="myWindow"
  >
    <div class="contract-info">
        <div class="fileUnit" v-if="formData.contract_file">
          <div class="u1">
            <img src="../../../../../assets/image/contract_file.png"/>
            <p>{{formData.contract_fname}}</p>
          </div>

          <!--
          <p>0.01M</p>
          <p>2022-11=07</p>-->

          <img class="close" @click="removeFile" 
          src="../../../../../assets/image/contract_remove.png"/>

        </div>

      
      <el-upload
          class="upload"
          drag
          :action="uploadFileUrl"
          :file-list="fileList"
          :limit="1"
          :on-error="handleUploadError"
          :on-exceed="handleExceed"
          :on-success="handleUploadSuccess"
          :show-file-list="false"
      
      >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text"><em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">若文件合同有变更，请删除废弃的合同文件！</div>
        </el-upload>


    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="send">确定</el-button>
      <el-button @click="visible = false">取 消</el-button>
    </span>

  </el-dialog>
</template>

<script>
import urlConfig from '@/api/config'

//import { contractShow,contractUpdate} from "@/api/director/work/recruit/index";

export default {
  components: {
  },
  data() {
    return {
      visible: false,
      uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址
      fileList: [],

      formData: {
        enroll_id:[],
        contract_type:2,
        relation_status:"12",
        contract_file:"",
        contract_fname:""
      },
    };
  },

 
  mounted() {

  },
  
  methods: {
    handleClose() {
      this.visible = false;
      this.$refs["form"].resetFields();

    },

    removeFile(){
      this.fileList=[];
      this.formData.contract_file='';
      this.formData.contract_fname='';
    },


    init(enroll_id) {//enroll_id
      this.visible = true;
      this.formData.enroll_id=[enroll_id];

    },


    
    send(){
      var that=this;
      if(this.formData.contract_file==""||this.formData.contract_fname==""){
        that.$message.error("请上传合同");
        return;

      }
     
      contractUpdate (that.formData).then((response) => {
            console.log(response);
            if(response.code==200){
              this.$message({
                  message: "提交成功",
                  type: 'success'
              });
              that.$emit('refresh');
              that.visible = false;
            
            }else{
              this.$message({
                message: response.msg?response.msg:"提交失败",
              });
            }
          });
    },



     // 文件个数超出
     handleExceed() {
      this.$message.error(`只允许上传单个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      console.log(res);
      this.formData.contract_file=res.file;
      this.formData.contract_fname=res.filename;
      this.$message.success("上传成功");
      console.log(this.formData);
     
    },
    // 删除文件
    handleDelete(index) {
     // this.fileList.splice(index, 1);
      this.fileList=[];
      this.formData.contract_file='';
      this.formData.contract_fname='';
     
    },
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
      } else {
        return "";
      }
    }

  },

 
};
</script>

<style lang="scss" scoped>

.contract-info{
  text-align: center;

  .fileUnit{
    display: flex;
    justify-content: space-between;
    position: relative;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    margin-bottom: 20px;
    padding: 10px;
    align-items: center;

    .u1{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img{
        width:32px
      }
    }
    .close{
      position: absolute;
      right: -15px;
      top: -15px;
      width: 30px;
    }
  }
}

  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
 
::v-deep .el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
}


::v-deep .el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
     width: 100%;
    height: 180px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
}

::v-deep .el-upload{
  width:100%
}

.upload{
  width: 100%;
}

</style>
